var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatternElement3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 540,
    viewBox: "0 0 501 540",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_2484",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -129,
    y: 0,
    width: 630,
    height: 1298
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 501,
    y: 1297.06,
    width: 630,
    height: 1297.06,
    transform: "rotate(-180 501 1297.06)",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_2484)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501 216.18L297.236 432.361L93.5044 648.332L297.236 648.332L93.5044 864.489L-110.047 1080.67L-314.008 1297.06L-517.935 1297.06L-314.008 1080.67L-110.047 864.489L-314.008 864.489L-517.935 864.489L-718.235 1077.42L-718.235 861.266L-517.935 648.332L-314.008 432.361L-314.008 648.332L-110.047 648.332L93.5044 432.361L297.236 216.18L501 0L501 216.18ZM91.979 216.081L-111.202 432.163L-314.775 216.08L-518.299 432.163L-718.235 644.584L-718.235 428.502L-518.299 216.08L-314.775 -0.00239065L-111.202 216.081L91.9791 -0.00235509L295.324 -0.00233732L91.979 216.081Z",
    fill: "url(#paint0_linear_3_2484)",
    fillOpacity: 0.99
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_2484",
    x1: -108.617,
    y1: -0.00225056,
    x2: -108.617,
    y2: 1297.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6FBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.99
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternElement3);
export default __webpack_public_path__ + "static/media/Pattern Element 3.bf1053efe243a6937001cbbf1d0eb1b1.svg";
export { ForwardRef as ReactComponent };